import React from 'react';

const Info = () => {
  return (
    <div className="education__info grid">
        <div className="education__box">
            <i className='bx bx-code about__icon'></i>
            <h3 className="education__title"> Computer Programming & Analysis</h3>
            <span className="education__subtitle">George Brown, CA. </span>
        </div>

        <div className="education__box">
            <i className='bx bx-camera about__icon'></i>
            <h3 className="education__title">Bachelor's in Advertising</h3>
            <span className="education__subtitle">Universidad Jorge Tadeo Lozano, Col.</span>
        </div>

    

          <div className="education__box">
            <i className='bx bx-folder-code about__icon'></i>
            <h3 className="education__title">*Full-Stack Developer</h3>
            <span className="education__subtitle">Code Academy (on-going).</span>

            <h3 className="education__title">*Front-End Developer</h3>
            <span className="education__subtitle">Facebook/Meta.</span>
            
        </div>
           
    </div>
  );
};

export default Info;